import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const serviceSections = [
  {
    id: "it-staffing",
    number: "01",
    title: "IT Staffing",
    subtitle: "Hire Skilled IT Talent On-Demand. Save Time. Stay Competitive.",
    subHeadings: [
      "Overview",
      "About PSRIT",
      "Why choose PSRIT",
      "Industries We Serve",
      "Start Hiring Today",
    ],
    content: (
      <>
        <p>
          Need to scale your tech team quickly without compromising on quality?
          Our IT staffing solutions connect you with experienced, U.S.-based and
          global tech professionals—fast. Whether you’re filling one role or
          building an entire team, we deliver the right talent to keep your
          business moving forward.
        </p>
        <h6 id="it-staffing-About PSRIT">About PSRIT</h6>
        <p>We help companies of all sizes find qualified IT experts for:</p>
        <ul>
          <li>Full-time, contract, and contract-to-hire roles</li>
          <li>Software Developers</li>
          <li>Cloud & DevOps Engineers</li>
          <li>Data Analysts & Machine Learning Engineers</li>
          <li>IT Support, QA, and Cybersecurity Specialists</li>
          <li>Project Managers & Technical Leads</li>
        </ul>
        <h6 id="it-staffing-Why choose PSRIT">Why choose PSRIT</h6>
        <ul>
          <li>✅ Fast Hiring Process</li>
          <li>✅ Flexible Hiring Options</li>
          <li>✅ Vetted Tech Talent</li>
          <li>✅ Cost-Effective Solutions</li>
        </ul>
        <h6 id="it-staffing-Industries We Serve">Industries We Serve</h6>
        <ul>
          <li>Healthcare</li>
          <li>Finance & Insurance</li>
          <li>E-commerce</li>
        </ul>
        <h6 id="it-staffing-Start Hiring Today">Start Hiring Today</h6>
        <p>
          Looking for reliable IT staffing support? Our team is ready to help
          you hire smarter and scale faster.
        </p>
        <h6 id="dev-staffing-Next Step">Build a Smarter, Faster Tech Team</h6>
        <p>
          Finding the right tech talent shouldn’t slow you down. Our IT staffing
          solutions connect you with pre-vetted developers, engineers, and IT
          specialists who match your project needs and company culture.
        </p>
      </>
    ),
  },
  {
    id: "dev-staffing",
    number: "02",
    title: "IT & Software Development Staffing",
    subtitle: "Scale Your Dev Team with Proven Experts—Fast.",
    subHeadings: [
      "Overview",
      "Specialized Roles",
      "Why choose PSRIT",
      "Industries Supported",
    ],
    content: (
      <>
        <p>
          PSRIT’s IT and software development staffing services help companies
          like yours hire experienced developers, engineers, and technical
          specialists on-demand. We connect you with top-tier candidates who are
          ready to contribute from day one—no long hiring cycles or guesswork.
        </p>
        <h6 id="dev-staffing-Specialized Roles">
          Specialized Staffing for IT & Software Development Roles
        </h6>
        <ul>
          <li>Front-End Developers (React, Angular, Vue.js)</li>
          <li>Back-End Developers (Java, Python, Node.js, .NET)</li>
          <li>Full-Stack Engineers</li>
          <li>Mobile App Developers (iOS, Android, Flutter, React Native)</li>
          <li>DevOps & Cloud Engineers (AWS, Azure, Google Cloud)</li>
          <li>QA Engineers & Automation Testers</li>
          <li>UI/UX Designers</li>
          <li>Project Managers, Scrum Masters, and Product Owners</li>
        </ul>
        <h6 id="dev-staffing-Why choose PSRIT">Why choose PSRIT</h6>
        <ul>
          <li>✅ Fast, Reliable Hiring</li>
          <li>✅ Flexible Staffing Options</li>
          <li>✅ Industry-Specific Expertise</li>
          <li>✅ U.S.-Based Support & Global Talent Pool</li>
          <li>✅ Reduce Overhead</li>
        </ul>
        <h6 id="dev-staffing-Industries Supported">
          Industries supported by PSRIT
        </h6>
        <ul>
          <li>Tech Startups & SaaS Companies</li>
          <li>Healthcare IT & HealthTech</li>
          <li>Finance & Fintech</li>
          <li>Retail, E-commerce & Logistics</li>
          <li>Manufacturing & Enterprise IT</li>
        </ul>
        <h6 id="dev-staffing-Next Step">Let’s Build Your Development Team</h6>
        <p>
          Stop losing time on unqualified applicants. Let us deliver proven IT
          professionals and developers who can help you ship faster, scale
          smarter, and stay competitive.
        </p>
      </>
    ),
  },
  {
    id: "corporate-training",
    number: "03",
    title: "Corporate Training",
    subtitle:
      "Upskill Your Workforce. Boost Productivity. Drive Business Growth.",
    subHeadings: [
      "Overview",
      "Training Programs",
      "Why Choose PSRIT",
      "Industries Served",
    ],
    content: (
      <>
        <p>
          Give your employees the tools to succeed. Our tailored corporate
          training programs help companies improve team performance, close skill
          gaps, and stay competitive in today’s fast-moving market.
        </p>
        <h6 id="corporate-training-Training Programs">
          PSRIT’s Training Programs
        </h6>
        <ul>
          <li>Leadership & Management Training</li>
          <li>Soft Skills & Communication</li>
          <li>
            IT & Technical Training (Software, Cybersecurity, Data Analytics)
          </li>
          <li>Sales & Customer Service Development</li>
          <li>Remote & Hybrid Team Training</li>
        </ul>
        <h6 id="corporate-training-Why Choose PSRIT">Why Choose PSRIT?</h6>
        <ul>
          <li>✅ Customized Content</li>
          <li>✅ Expert Instructors</li>
          <li>✅ Flexible Delivery</li>
          <li>✅ Actionable Results</li>
          <li>✅ Scalable Solutions</li>
        </ul>
        <h6 id="corporate-training-Industries Served">Industries served</h6>
        <ul>
          <li>Tech & IT</li>
          <li>Healthcare</li>
          <li>Finance & Insurance</li>
        </ul>
        <h6 id="dev-staffing-Next Step">
          Training That Drives Business Results
        </h6>
        <p>
          From IT tools to leadership development, our corporate training
          programs help your teams work smarter, adapt faster, and stay ahead of
          the curve.
        </p>
      </>
    ),
  },
  {
    id: "cloud-solutions",
    number: "04",
    title: "Cloud Solutions",
    subtitle: "Cloud Solutions That Accelerate Digital Transformation",
    subHeadings: [
      "Overview",
      "Our Cloud Services",
      "Why Choose PSRIT’s Cloud",
      "Industries Served",
    ],
    content: (
      <>
        <p>
          Stay ahead in a digital-first world with cloud solutions designed to
          improve performance, reduce costs, and drive innovation. PSRIT’s cloud
          services help you migrate to the cloud, optimize your existing
          infrastructure, or build cloud-native applications- efficiently.
        </p>
        <h6 id="cloud-solutions-Our Cloud Services">PSRIT’s Cloud Services</h6>
        <ul>
          <li>
            Cloud Migration Services – Seamless transition from on-premise to
            cloud
          </li>
          <li>
            Cloud Architecture & Consulting – Strategic planning for scalable
            cloud infrastructure
          </li>
          <li>
            DevOps & Cloud Automation – Streamlined CI/CD pipelines and
            infrastructure as code
          </li>
          <li>
            Hybrid & Multi-Cloud Solutions – Flexible deployments across AWS,
            Azure, and GCP
          </li>
          <li>
            Cloud Security & Compliance – Built-in protection for data,
            applications, and workloads
          </li>
          <li>
            Managed Cloud Services – 24/7 monitoring, optimization, and support
          </li>
        </ul>
        <h6 id="cloud-solutions-Why Choose PSRIT’s Cloud">
          🔧 Why Choose PSRIT’S Cloud Solutions?
        </h6>
        <ul>
          <li>✅ Certified Cloud Experts</li>
          <li>✅ Faster Cloud Adoption</li>
          <li>✅ Customized Cloud Strategies</li>
          <li>✅ End-to-End Cloud Management</li>
          <li>✅ Security-First Cloud Solutions</li>
        </ul>
        <h6 id="cloud-solutions-Industries Served">
          Industries We Serve with Cloud Solutions
        </h6>
        <ul>
          <li>Finance & Fintech Cloud Solutions</li>
          <li>Healthcare Cloud Services</li>
          <li>Retail & E-Commerce Cloud Migration</li>
        </ul>
      </>
    ),
  },
];

export default function Services() {
  return (
    <section
      id="services"
      className="py-5"
      style={{ backgroundColor: "#fffcf5" }}
    >
      <div className="container">
        <div className="row">
          {/* Left Column */}
          <div className="col-lg-8">
            <h2
              className="mb-4 text-center"
              style={{ color: "#4a1717", fontWeight: 700 }}
            >
              Our Services
            </h2>
            <div className="row gy-4">
              {serviceSections.map((sec, idx) => {
                const bgColor = idx % 2 === 0 ? "#2c2c2c" : "#39414a";
                return (
                  <div className="col-md-6" key={sec.id}>
                    <div
                      className="p-4 d-flex flex-column h-100"
                      style={{
                        backgroundColor: bgColor,
                        borderRadius: "12px",
                        color: "#fffcf5",
                      }}
                    >
                      <h5
                        style={{ color: idx % 2 === 0 ? "#ffcccb" : "#b2f5ea" }}
                      >
                        {sec.number}
                      </h5>
                      <h4 style={{ color: "#fffcf5" }}>{sec.title}</h4>
                      <p className="fst-italic" style={{ opacity: 0.9 }}>
                        {sec.subtitle}
                      </p>
                      <hr
                        style={{
                          borderColor: idx % 2 === 0 ? "#ffcccb" : "#b2f5ea",
                        }}
                      />
                      <div className="flex-grow-1">{sec.content}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Sidebar */}
          <div className="col-lg-4">
            <div className="sticky-top" style={{ top: "100px" }}>
              <div
                className="p-4 mb-4"
                style={{
                  backgroundColor: "#fff",
                  border: "2px solid #4a1717",
                  borderRadius: "12px",
                }}
              >
                <h5
                  className="mb-3"
                  style={{ color: "#4a1717", fontWeight: 600 }}
                >
                  CONTENT STRUCTURE
                </h5>
                <ul className="list-unstyled mb-0">
                  {serviceSections.map((sec) => (
                    <li key={sec.id} className="mb-2">
                      <strong style={{ color: "#4a1717" }}>{sec.title}</strong>
                      <ul style={{ paddingLeft: "1rem", marginTop: "0.5rem" }}>
                        {sec.subHeadings.map((sub) => (
                          <li key={sub} className="mb-1">
                            <a
                              href={`#${sec.id}-${sub}`}
                              style={{
                                color: "#4a1717",
                                textDecoration: "none",
                              }}
                            >
                              {sub}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
